import Cookie from "js-cookie";

export const generateTimeInMinutes = (time: number): Date => {
  if (!time) return null;
  return new Date(new Date().getTime() + time * 60 * 1000);
};

export const removeFrontierCookie = () => {
  if (Cookie.get("frontierSiteDetailPredictive")) {
    Cookie.remove("frontierSiteDetailPredictive", {
      path: "/",
      domain: window?.location?.hostname === "localhost" ? "localhost" : ".frontier.com",
    });
  }
};

export const hashSHA256 = async (message: string) => {
  if (typeof window !== "undefined") {
    const msgUint8 = new TextEncoder().encode(message?.toLowerCase()?.trim()); // encode as (utf-8) Uint8Array
    const hashBuffer = await window.crypto?.subtle.digest("SHA-256", msgUint8); // hash the message
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join(""); // convert bytes to hex string
    return hashHex;
  }
};

/** Page URL for Rezync sync; falls back to iframe URL when `window.top` is cross-origin (e.g. cart embedded on ctest). */
export const getZyncPageUrl = (): string => {
  try {
    return window.top.location.href;
  } catch {
    return window.location.href;
  }
};

export const zync_call = (productID?: string) => {
  const z = document.createElement("script");
  const zmpID = "frontier-communications";
  const cache_buster = Date.now();
  let page_referrer = "";
  if (document.referrer?.length > 0) {
    const ref = new URL(document.referrer);
    page_referrer = encodeURIComponent(ref.origin + ref.pathname);
  }
  const PageUrl = encodeURIComponent(getZyncPageUrl())
    .replace(/[!'()~]/g, escape)
    .replace(/\*/g, "%2A");

  let z_src =
    "https://live.rezync.com/sync?c=16b6410431b6374e780104abb0443ca8&p=79cddb8b04ec00c93c748618dfca8efc&k=frontier-communications-pixel-6788&zmpID=" +
    zmpID +
    "&cache_buster=" +
    cache_buster +
    "&page_referrer=" +
    page_referrer +
    "&PageUrl=" +
    PageUrl;
  if (productID) {
    z_src += "&productID=" + productID;
  }
  z.setAttribute("src", z_src);
  document.body.appendChild(z);
};

export const purchase_zync_call = (productID?: string, OrderAmount?: string) => {
  const z = document.createElement("script");
  const zmpID = "frontier-communications";
  const cache_buster = Date.now();
  let page_referrer = "";
  if (document.referrer?.length > 0) {
    const ref = new URL(document.referrer);
    page_referrer = encodeURIComponent(ref.origin + ref.pathname);
  }
  const PageUrl = encodeURIComponent(getZyncPageUrl())
    .replace(/[!'()~]/g, escape)
    .replace(/\*/g, "%2A");
  const z_src =
    "https://live.rezync.com/sync?c=16b6410431b6374e780104abb0443ca8&p=79cddb8b04ec00c93c748618dfca8efc&k=frontier-communications-pixel-6657&zmpID=" +
    zmpID +
    "&productID=" +
    productID +
    "&OrderAmount=" +
    OrderAmount +
    "&cache_buster=" +
    cache_buster +
    "&page_referrer=" +
    page_referrer +
    "&PageUrl=" +
    PageUrl;
  z.setAttribute("src", z_src);
  document.body.appendChild(z);
};
